import { PaginationDetails } from "./api_request";

export interface MedicContentProps {
  medicList: any[];
  loading: boolean;
  stats: {
    totalMedics: number;
    vettedMedics: number;
    unvettedMedics: number;
  };
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
  paginationState: PaginationDetails;
  setPaginationState: React.Dispatch<React.SetStateAction<PaginationDetails>>;
}
export interface MedicTableProps {
  data: any[];
  loading: boolean;
}

export interface MedicInformationProps {
  address: string;
  affiliated_council: string;
  avatar: string;
  city: string;
  created_at: string;
  device: string;
  dob: string;
  email: string;
  employment: any;
  employment_details: {
    status: string;
    employment: string;
    facility: string;
    facility_info: { name: string; city: string; state: string };
  };
  facility: any;
  facility_info: any;
  first_name: string;
  freeze: boolean;
  gender: string;
  isSignupCompleted: boolean;
  isVerified: boolean;
  lastLogin: string;
  last_name: string;
  level: number;
  medic_type: string;
  middle_name: string;
  phone_number: string;
  role: string;
  state: string;
  suspended: boolean;
  tag: { note: string; status: boolean; taggedAt: any; admin: any };
  type: string;
  updated_at: string;
  verification: string;
  years_of_experience: string;
  _id: string;
  folio_no?: string;
  documents: {
    Annual_practicing_license: string;
    Full_registration: string;
    NYSC_discharge: string;
  };
}

export const MedicInformationDummyData = {
  address: "",
  affiliated_council: "",
  avatar: "",
  city: "",
  created_at: "",
  device: "",
  dob: "",
  email: "",
  employment: null,
  employment_details: {
    status: "",
    employment: "",
    facility: "",
    facility_info: { name: "", city: "", state: "" },
  },
  facility: null,
  facility_info: null,
  first_name: "",
  freeze: false,
  gender: "",
  isSignupCompleted: false,
  isVerified: false,
  lastLogin: "",
  last_name: "",
  level: 0,
  medic_type: "",
  middle_name: "",
  phone_number: "",
  role: "",
  state: "",
  suspended: false,
  tag: { note: "", status: false, taggedAt: null, admin: null },
  type: "",
  updated_at: "",
  verification: "",
  years_of_experience: "",
  _id: "",
};

export interface MedicInfoProps {
  avatar: string;
  created_at: string;
  device: string;
  dob: string;
  email: string;
  first_name: string;
  freeze: boolean;
  gender: string;
  isDeleted: boolean;
  isSignupCompleted: boolean;
  isVerified: boolean;
  last_name: string;
  level: number;
  medic_type: string;
  middle_name: string;
  password: string;
  phone_number: string;
  role: string;
  suspended: boolean;
  tag: { note: string; status: boolean; taggedAt: null; admin: null };
  type: string;
  updated_at: string;
  _id: string;
}

export const MedicInfoDummyText = {
  avatar: "",
  created_at: "2024-10-03T16:14:25.799Z",
  device: "android",
  dob: "1935-10-03T15:40:00.000Z",
  email: "ecovanguardclub@gmail.com",
  first_name: "tunde",
  freeze: false,
  gender: "male",
  isDeleted: false,
  isSignupCompleted: true,
  isVerified: true,
  last_name: "cody",
  level: 0,
  medic_type: "nurse",
  middle_name: "dev",
  password: "$2a$10$Zxm8UeTW//R7tyHBU7h12egm/zct4E7rMOgodjb/PsdbihwoUeX8.",
  phone_number: "2348030437026",
  role: "user",
  suspended: false,
  tag: { note: "", status: false, taggedAt: null, admin: null },
  type: "medic",
  updated_at: "2024-10-03T16:43:55.945Z",
  _id: "66feb4d10eb3fe510ccaa104",
};
export interface MedicStatsProps {
  totalEmployment: number;
  totalApplications: number;
  totalShifts: number;
  totalAbsent: number;
  totalCompletedShift: number;
}
export const MedicStatsDummy = {
  totalEmployment: 0,
  totalApplications: 0,
  totalShifts: 0,
  totalAbsent: 0,
  totalCompletedShift: 0,
};

export interface MedicTimesheetInfo {
  _id: string;
  facility: string;
  facility_info: {
    name: string;
    facility_type: string;
  };
  shift_info: {
    start_time: string;
    end_time: string;
    employee: string;
    created_at: string;
    schedule: string;
    schedule_name: string;
  };
  shift: string;
  medic: string;
  medic_info: {
    name: string;
    medic_type: string;
  };
  status: string;
  clock_in_time: string;
  created_at: string;
  updated_at: string;
  clock_out_time: string;
  overtime_hours: number;
  total_hours: number;
}

export const MedicTimesheetInfoDummyData = {
  _id: "",
  facility: "",
  facility_info: {
    name: "",
    facility_type: "",
  },
  shift_info: {
    start_time: "",
    end_time: "",
    employee: "",
    created_at: "",
    schedule: "",
    schedule_name: "",
  },
  shift: "",
  medic: "",
  medic_info: {
    name: "",
    medic_type: "",
  },
  status: "",
  clock_in_time: "",
  created_at: "",
  updated_at: "",
  clock_out_time: "",
  overtime_hours: 0,
  total_hours: 0,
};

export interface MedicAppraisalProp {
  _id: string;
  employee: string;
  performance_rating: string;
  strengths: string[];
  appraisal_type: string;
  comment: string;
  goals: string;
  overall_summary: string;
  facility: string;
  facility_info: {
    name: string;
    email: string;
  };
  employee_info: {
    name: string;
    medic_type: string;
  };
  medic: string;
  medic_info: {
    name: string;
    state: string;
    medic_type: string;
  };
  created_at: string;
  updated_at: string;
}

export const MedicAppraisalPropDummy = {
  _id: "",
  employee: "",
  performance_rating: "",
  strengths: [""],
  appraisal_type: "",
  comment: "",
  goals: "",
  overall_summary: "",
  facility: "",
  facility_info: {
    name: "",
    email: "",
  },
  employee_info: {
    name: "",
    medic_type: "",
  },
  medic: "",
  medic_info: {
    name: "",
    state: "",
    medic_type: "",
  },
  created_at: "",
  updated_at: "",
};

export interface MedicEmploymentProps {
  _id: string;
  application: string;
  job: string;
  job_info: {
    job_title: string;
    job_type: string;
    department: string;
    employment_type: string;
    work_type: string;
    contract_duration: string;
    work_location: string;
  };
  facility: string;
  facility_info: {
    name: string;
  };
  medic: string;
  medic_info: {
    name: string;
    state: string;
    medic_type: string;
  };
  performance_review: {
    date: any;
    rating: number;
    comment: string;
  };
  employment_details: {
    start_date: string;
    end_date: string;
    salary: number;
    benefits: string;
    positon: string;
  };
  status: string;
  note: string;
  created_at: string;
  updated_at: string;
  ended_date: string;
  reasons: string;
}
